import { useState } from 'react'
import Lightbox from '../components/Lightbox'
import ThumbnailPicker from '../components/ThumbnailPicker'
import ImageLoader from '../components/ImageLoader'


const items = [
    { src:require("../images/interiors/img--bathroom-dark.jpg").default, src2:require("../images/interiors/img--bathroom-light.jpg").default, caption:"Spark", caption2:"Ember", x:595, y:373, width:530, height:398 },
    { src:require("../images/interiors/img--kitchen-2-dark.jpg").default, src2:require("../images/interiors/img--kitchen-2-light.jpg").default, caption:"Spark", caption2:"Ember", x:1145, y:600, width:675, height:380 },
    { src:require("../images/interiors/img--kitchen-1-dark.jpg").default, src2:require("../images/interiors/img--kitchen-1-light.jpg").default, caption:"Spark", caption2:"Ember", x:1145, y:200, width:675, height:381 },
]


export default function(){
    const [selection, setSelection] = useState<string|null>(null);

    return (
        <div>
            <ThumbnailPicker onSelected={setSelection} items={items}/>
            <Lightbox items={items} selection={selection} onSelected={setSelection} carousel={false} />
            <ImageLoader src={require("../images/interiors/bkg--interiors-2.jpg").default} />
        </div>
    )
}